(function() {
  var $5902efa275186a09$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("date-input-overlay")) return;
    customElements.define("date-input-overlay", class DateInputOverlay extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector("[data-date-overlay-input]");
        this.label = this.querySelector("[data-date-overlay-label]");
        if (!this.input || !this.label) return;
        this.emptyLabel = this.dataset.emptyLabel || "";
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onHostClick = this.onHostClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.input.addEventListener("focus", this.onFocus);
        this.input.addEventListener("blur", this.onBlur);
        this.addEventListener("mouseenter", this.onMouseEnter);
        this.addEventListener("mouseleave", this.onMouseLeave);
        this.addEventListener("click", this.onHostClick);
        this.input.addEventListener("change", this.onChange);
        this.ensureMinDate();
        this.label.textContent = this.emptyLabel;
        this.syncFloatingState();
      }
      disconnectedCallback() {
        this.input?.removeEventListener("focus", this.onFocus);
        this.input?.removeEventListener("blur", this.onBlur);
        this.removeEventListener("mouseenter", this.onMouseEnter);
        this.removeEventListener("mouseleave", this.onMouseLeave);
        this.removeEventListener("click", this.onHostClick);
        this.input?.removeEventListener("change", this.onChange);
      }
      onFocus() {
        this.classList.add("is-focused");
        this.classList.add("is-floating");
      }
      onBlur() {
        this.classList.remove("is-focused");
        this.syncFloatingState();
      }
      onMouseEnter() {
        if (this.input?.disabled) return;
        this.classList.add("is-hovered");
        this.classList.add("is-floating");
      }
      onMouseLeave() {
        this.classList.remove("is-hovered");
        this.syncFloatingState();
      }
      onHostClick(event) {
        if (!this.input || this.input.disabled) return;
        if (event.target === this.input) return;
        this.input.focus();
        if (typeof this.input.showPicker === "function") this.input.showPicker();
      }
      onChange() {
        this.syncFloatingState();
      }
      getTodayISO() {
        const now = new Date;
        const year = String(now.getFullYear());
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
      ensureMinDate() {
        if (!this.input || this.input.min) return;
        this.input.min = this.getTodayISO();
      }
      syncFloatingState() {
        const hasValue = Boolean(this.input?.value);
        const shouldFloat = hasValue || this.classList.contains("is-focused") || this.classList.contains("is-hovered");
        this.classList.toggle("is-floating", shouldFloat);
      }
    });
  })();
})();